import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsAdvanced = ({ onSubmit = () => {}, onBack = () => {}, inputs, canGoNext }) => {
  const { t } = useTranslation(['rewards-loyalty', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view loyalty-advanced">
        <div className="rewards-modal-input-row">
          {inputs.first && (
            <div className="input-container">
              <div className="input-label">{inputs.first.label}</div>
              {inputs.first.render()}
            </div>
          )}
        </div>
        {inputs.second && (
          <div className="rewards-modal-input-row">
            <div className="input-container">{inputs.second.render()}</div>
          </div>
        )}
        {inputs.third && inputs.third.isVisible && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className={`input-label ${inputs.third.disabled ? 'disabled' : ''}`}>
                {inputs.third.label}
              </div>
              {inputs.third.render()}
            </div>
          </div>
        )}
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button
          className="button button-primary auto-width"
          disabled={!canGoNext}
          onClick={onSubmit}
        >
          {t('rewards-loyalty:loyaltyTable.addActivityButton')}
        </button>
      </div>
    </div>
  )
}

RewardsAdvanced.propTypes = {
  onSubmit: PropTypes.func,
  onBack: PropTypes.func,
  inputs: PropTypes.object,
  canGoNext: PropTypes.bool,
}

export default RewardsAdvanced
